var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "upDataIDDiv" },
    [
      _vm.successfulData
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "upDataID",
              attrs: { "element-loading-text": "上传中，请稍后..." },
            },
            [
              _c("h3", { staticClass: "upDataIDH32" }, [
                _vm._v("上传身份证照片"),
              ]),
              _vm._m(0),
              _c(
                "div",
                {
                  class: _vm.msgData ? "reverse reverseErr" : "reverse",
                  on: {
                    click: function ($event) {
                      return _vm.isOpen(0)
                    },
                  },
                },
                [
                  _vm.reverseData
                    ? _c("img", {
                        staticClass: "reverseImg2",
                        attrs: { src: _vm.reverseData, alt: "" },
                      })
                    : _c("img", {
                        staticClass: "reverseImg2",
                        attrs: {
                          src: require("@/assets/images/upData/upData.png"),
                          alt: "",
                        },
                      }),
                  _c("p", [_vm._v("点击上传身份证人像面")]),
                ]
              ),
              _c(
                "p",
                {
                  staticStyle: {
                    "font-size": "15px",
                    color: "#df3030",
                    "margin-top": "10px",
                  },
                },
                [_vm._v(" " + _vm._s(_vm.msgData) + " ")]
              ),
              _c(
                "div",
                {
                  staticClass: "reverse",
                  on: {
                    click: function ($event) {
                      return _vm.isOpen(1)
                    },
                  },
                },
                [
                  _vm.positiveData
                    ? _c("img", {
                        staticClass: "reverseImg2",
                        attrs: { src: _vm.positiveData, alt: "" },
                      })
                    : _c("img", {
                        staticClass: "reverseImg2",
                        attrs: {
                          src: require("@/assets/images/upData/upData2.png"),
                          alt: "",
                        },
                      }),
                  _c("p", [_vm._v("点击上传身份证国徽面")]),
                ]
              ),
              _c("div", { staticStyle: { width: "100%", height: "40px" } }),
              _c(
                "button",
                {
                  class: _vm.modelType ? "button2State" : "button2",
                  on: {
                    click: function ($event) {
                      return _vm.upDataImg()
                    },
                  },
                },
                [_vm._v(" 开始上传 ")]
              ),
            ]
          )
        : _c("div", { staticClass: "upDataID" }, [
            _c("em", { staticClass: "successfulIcon" }),
            _c("p", { staticClass: "successfulTitle" }, [_vm._v("提交成功")]),
            _c("p", { staticClass: "successfulText" }, [
              _vm._v("若电脑网页5秒后未跳转，请刷新页面"),
            ]),
          ]),
      _c(
        "el-drawer",
        {
          attrs: {
            visible: _vm.drawer,
            modal: false,
            "show-close": false,
            direction: _vm.direction,
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _c("ul", { staticClass: "chooseUpdata" }, [
            _c("li", [
              _vm._v(" 拍照上传 "),
              _c("input", {
                staticClass: "input",
                attrs: {
                  type: "file",
                  accept: "image/*",
                  capture: "camera",
                  value: "",
                },
                on: {
                  change: function ($event) {
                    return _vm.isUpData($event)
                  },
                },
              }),
            ]),
            _c("li", [
              _vm._v(" 从手机相册选择"),
              _c("input", {
                staticClass: "input",
                attrs: { type: "file", accept: "image/*", value: "" },
                on: {
                  change: function ($event) {
                    return _vm.isUpData($event)
                  },
                },
              }),
            ]),
            _c(
              "li",
              {
                on: {
                  click: function ($event) {
                    _vm.drawer = false
                  },
                },
              },
              [_vm._v("取消")]
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("p", { staticClass: "upDataIDH3P2" }, [
        _vm._v(" 1. 请确保照片的清晰完整度，仅支持jpg、png格式，小于2M； "),
      ]),
      _c("p", { staticClass: "upDataIDH3P2" }, [_vm._v("2. 请上传彩色图像。")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }